import { render, staticRenderFns } from "./SelectedFiltersChip.vue?vue&type=template&id=cb650422"
import script from "./SelectedFiltersChip.vue?vue&type=script&lang=ts"
export * from "./SelectedFiltersChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports